import React, { type FunctionComponent, useMemo } from 'react'
import styled from '@emotion/styled'
import { FilterPill } from './FilterPill'

const FilterPillContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
})

export interface Filter {
  name: string
  onRemove: () => void
  id: string
}

interface FilterPillsProps {
  filters: Filter[]
}

export const FilterPills: FunctionComponent<FilterPillsProps> = ({ filters }) => {
  const renderedFilterPills = useMemo(
    () =>
      filters.map(filter => (
        <FilterPill name={filter.name} key={filter.id} onRemove={filter.onRemove} />
      )),
    [filters]
  )
  return <FilterPillContainer>{renderedFilterPills}</FilterPillContainer>
}
